import { environment } from '../../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { PhoneNumberFormatModuleId } from '../constants/modules.constant';

@Injectable({ providedIn: 'root' })
export class PhoneNumberFormatService {

    private phoneNumberFormat: BehaviorSubject<any>;
    private phoneNumberFormatResponse: BehaviorSubject<any>;
    public phoneNumberFormat$: Observable<any>;
    constructor(
        private http: HttpClient
    ) {
        this.phoneNumberFormat = new BehaviorSubject<any>(null);
        this.phoneNumberFormatResponse = new BehaviorSubject<any>(null);
        this.phoneNumberFormat$ = this.phoneNumberFormat.asObservable();
    }

    public get numberFormatValue(): any {
        return this.phoneNumberFormat.value;
    }
    public get numberFormatResponseValue(): any {
        return this.phoneNumberFormatResponse.value;
    }

    public removeMaskingFromNumber(phoneNumber: string): string {
        const phoneNumberFormat = this.phoneNumberFormat?.getValue();
        phoneNumber = phoneNumber.replace(/_/g, "");
        if (phoneNumberFormat) {
            // Create a regex pattern that allows for optional non-digit characters
            const regexPattern = phoneNumberFormat
                .replace(/9/g, '\\d')
                .replace(/([^\d])/g, '\\$1?'); // Escape and make non-digit characters optional
            const regex = new RegExp(`^${regexPattern}$`);
            const matches = regex.test(phoneNumber);
            if (matches) {
                return phoneNumber.replace(/\D/g, '');
            }
        }

        return phoneNumber ? phoneNumber.trim() : "";
    }

    public checkMaskingEnabled(phoneNumber: string): boolean {
        phoneNumber = phoneNumber ? phoneNumber.trim() : phoneNumber;
        // Regular expression to find non-digit characters
        const nonDigitRegex = /\D/;
        const nonDigits = nonDigitRegex.test(phoneNumber);
        if(nonDigits) return false;
        const phoneNumberFormat = this.phoneNumberFormat?.getValue();
        if(phoneNumberFormat){
            const formatLength = phoneNumberFormat.replace(/\D/g, '').length;
            const numberLength = phoneNumber.replace(/\D/g, '').length;

            if(numberLength<=formatLength || !phoneNumber){
                return true;
            }
        }

        return false;
    }

    public checkMaskingDisabled(phoneNumber: string): boolean {
        return !this.checkMaskingEnabled(phoneNumber);
    }

    async getPhoneNumberFormat(forceReload: boolean = false) {
        const phoneNumberFormat = this.phoneNumberFormatResponse?.getValue();
        if (phoneNumberFormat && !forceReload) {
            return this.phoneNumberFormat?.getValue();
        } else {
            await this.http.get<any>(`${environment.configUrlV2}/ModuleSetting?moduleId=${PhoneNumberFormatModuleId}`)
                .toPromise()
                .then(res => {
                    const numberFormatSettings = res?.[0]||null;
                    const numberFormat = (numberFormatSettings?.enabled && numberFormatSettings?.value) ? numberFormatSettings.value : null;
                    this.phoneNumberFormat.next(numberFormat);
                    this.phoneNumberFormatResponse.next(numberFormatSettings);
                });

            return this.phoneNumberFormat?.getValue();
        }
    }


}
